import { Container } from '@cgs/wge';
import { TrifectaDemoDataAccessService } from './trifecta-demo-data-access.service';

export class TrifectaReplayDataAccessService extends TrifectaDemoDataAccessService {
  constructor(container: Container) {
    super(container);
  }
}
